/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import AddIcon from '@mui/icons-material/Add';
import ArchiveIcon from '@mui/icons-material/Archive';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import BookmarkRemoveIcon from '@mui/icons-material/BookmarkRemove';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import DownloadIcon from '@mui/icons-material/Download';
import EditNoteIcon from '@mui/icons-material/EditNote';
import HelpIcon from '@mui/icons-material/Help';
import InfoIcon from '@mui/icons-material/Info';
import LinkIcon from '@mui/icons-material/Link';
import MergeIcon from '@mui/icons-material/Merge';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PageviewOutlinedIcon from '@mui/icons-material/PageviewOutlined';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import RefreshIcon from '@mui/icons-material/Refresh';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import SaveIcon from '@mui/icons-material/Save';
import SettingsIcon from '@mui/icons-material/Settings';
import SyncIcon from '@mui/icons-material/Sync';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import WarningIcon from '@mui/icons-material/Warning';
import FolderDeleteIcon from '@mui/icons-material/FolderDelete';

type MuiIconsMaterialProps = any

export const ArgosFolderDeleteIcon = (props: MuiIconsMaterialProps) => {
  return (
    <FolderDeleteIcon
      {...props}
    />
  )
}
export const ArgosAddIcon = (props: MuiIconsMaterialProps) => {
  return (
    <AddIcon
      {...props}
    />
  )
}
export const ArgosAddFavoriteIcon = (props: MuiIconsMaterialProps) => {
  return (
    <BookmarkAddIcon
      {...props}
    />
  )
}

export const ArgosArchiveIcon = (props: MuiIconsMaterialProps) => {
  return (
    <ArchiveIcon
      {...props}
    />
  )
}

export const ArgosDeleteIcon = (props: MuiIconsMaterialProps) => {
  return (
    <DeleteIcon
      {...props}
    />
  )
}

export const ArgosDeleteAllIcon = (props: MuiIconsMaterialProps) => {
  return (
    <DeleteSweepIcon
      {...props}
    />
  )
}

export const ArgosDeleteAllAndSyncIcon = (props: MuiIconsMaterialProps) => {
  return (
    <RotateRightIcon
      {...props}
    />
  )
}

export const ArgosDownloadIcon = (props: MuiIconsMaterialProps) => {
  return (
    <DownloadIcon
      {...props}
    />
  )
}

export const ArgosEditIcon = (props: MuiIconsMaterialProps) => {
  return (
    <ModeEditIcon
      {...props}
    />
  )
}

export const ArgosBulkEditIcon = (props: MuiIconsMaterialProps) => {
  return (
    <EditNoteIcon
      {...props}
    />
  )
}

export const ArgosHelpIcon = (props: MuiIconsMaterialProps) => {
  return (
    <HelpIcon
      {...props}
    />
  )
}

export const ArgosInfoIcon = (props: MuiIconsMaterialProps) => {
  return (
    <InfoIcon
      {...props}
    />
  )
}

export const ArgosLinkIcon = (props: MuiIconsMaterialProps) => {
  return (
    <LinkIcon
      {...props}
    />
  )
}

export const ArgosMarkPlanOfRecordIcon = (props: MuiIconsMaterialProps) => {
  return (
    <PlaylistAddIcon
      {...props}
    />
  )
}

export const ArgosMergeIcon = (props: MuiIconsMaterialProps) => {
  return (
    <MergeIcon
      {...props}
    />
  )
}

export const ArgosMoreIcon = (props: MuiIconsMaterialProps) => {
  return (
    <MoreVertIcon
      {...props}
    />
  )
}

export const ArgosOpenInNewTabIcon = (props: MuiIconsMaterialProps) => {
  return (
    <OpenInNewIcon
      {...props}
    />
  )
}

export const ArgosPlanOfRecordIcon = (props: MuiIconsMaterialProps) => {
  return (
    <PlaylistAddCheckIcon
      {...props}
    />
  )
}

export const ArgosReloadIcon = (props: MuiIconsMaterialProps) => {
  return (
    <RefreshIcon
      {...props}
    />
  )
}

export const ArgosRemoveFavoriteIcon = (props: MuiIconsMaterialProps) => {
  return (
    <BookmarkRemoveIcon
      {...props}
    />
  )
}

export const ArgosSaveIcon = (props: MuiIconsMaterialProps) => {
  return (
    <SaveIcon
      {...props}
    />
  )
}

export const ArgosSettingsIcon = (props: MuiIconsMaterialProps) => {
  return (
    <SettingsIcon
      {...props}
    />
  )
}

export const ArgosSyncIcon = (props: MuiIconsMaterialProps) => {
  return (
    <SyncIcon
      {...props}
    />
  )
}

export const ArgosUnarchiveIcon = (props: MuiIconsMaterialProps) => {
  return (
    <UnarchiveIcon
      {...props}
    />
  )
}

export const ArgosUnmarkPlanOfRecordIcon = (props: MuiIconsMaterialProps) => {
  return (
    <PlaylistRemoveIcon
      {...props}
    />
  )
}

export const ArgosViewDetailsIcon = (props: MuiIconsMaterialProps) => {
  return (
    <PageviewOutlinedIcon
      {...props}
    />
  )
}

export const ArgosWarningIcon = (props: MuiIconsMaterialProps) => {
  return (
    <WarningIcon
      color={'warning'}
      {...props}
    />
  )
}

export const ArgosWizardIcon = (props: MuiIconsMaterialProps) => {
  return (
    <AutoFixHighIcon
      {...props}
    />
  )
}
